export const dealTypes = [
  { value: "", label: "All" },
  { value: "1", label: "Sale" },
  { value: "2", label: "Rent" },
  { value: "3", label: "Commercial" },
  { value: "4", label: "Investment" },
  { value: "5", label: "Development" },
  { value: "6", label: "Redevelopment" },
];

export const propertyTypes = [
  { value: "", label: "All" },
  { value: "1", label: "Apartment" },
  { value: "2", label: "Garden apartment" },
  { value: "3", label: "Detached (House)" },
  { value: "4", label: "Semi Detached (Cottage)" },
  { value: "5", label: "Penthouse" },
  { value: "6", label: "Studio / Loft" },
  { value: "7", label: "Holiday Rental Apartment" },
  { value: "8", label: "Basement Apartment" },
  { value: "9", label: "Complex living" },
  { value: "10", label: "Field" },
  { value: "11", label: "Assisted living facility" },
  { value: "12", label: "Entire Building" },
  { value: "13", label: "Hotel" },
  { value: "14", label: "Plot" },
  { value: "15", label: "Warehouse" },
  { value: "16", label: "Buying Group" },
  { value: "17", label: "Parking lot" },
  { value: "18", label: "Store" },
  { value: "19", label: "Office" },
  { value: "20", label: "Real estate for business" },
  { value: "21", label: "Yielding Real Estate" },
  { value: "22", label: "Other" },
  { value: "23", label: "Land" }, // need to check the actuall value from api
  { value: "24", label: "Project" }, // need to check the actuall value from api
];

export const airportType = [
  {
    value: "0",
    label: "Km",
  },
  {
    value: "1",
    label: "miles",
  },
];
export const buildingStatus = [
  {
    value: "",
    label: "None",
  },
  {
    value: "1",
    label: "Existing",
  },
  {
    value: "2",
    label: "Under Construction",
  },
  {
    value: "3",
    label: "Proposed",
  },
];
export const coinsType = [
  { value: "0", label: "None" },
  { value: "1", label: "₪" },
  { value: "2", label: "$" },
  { value: "3", label: "€" },
];
export const squareTypes = [
  { value: "0", label: "sq m." },
  { value: "1", label: "sq m." },
];
export const fullTextType = [
  { value: "0", label: "Custom text" },
  { value: "1", label: "Show default text" },
  { value: "2", label: "Leave blank" },
];
export const parkingTypes = [
  { value: "", label: "None" },
  { value: "1", label: "Covered" },
  { value: "2", label: "Reserved" },
  { value: "3", label: "Surface" },
  { value: "4", label: "Free" },
];
export const roomsType = [
  { value: "", label: "select" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10+" },
];
export const floorsType = [
  { value: "", label: "select" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10+" },
];
export const bathsType = [
  { value: "", label: "select" },
  { value: Number("1"), label: "1" },
  { value: Number("2"), label: "2" },
  { value: Number("3"), label: "3" },
  { value: Number("4"), label: "4" },
  { value: Number("5"), label: "5" },
  { value: Number("6"), label: "6" },
  { value: Number("7"), label: "7" },
  { value: Number("8"), label: "8" },
  { value: Number("9"), label: "9" },
  { value: Number("10"), label: "10+" },
];
export const metricsType = [
  { value: Number("0"), label: "sq m." },
  { value: Number("1"), label: "sq m." },
];
